import React, {useCallback} from 'react';
import {
  PropertyRow,
  formatDateToLocalDate,
  formatPhoneNumber,
  copyToClipboard,
  useNotifications,
  StatusLabel,
} from '../../../../shared';
import {Copy, Pencil} from '@gravity-ui/icons';
import {Text} from '@gravity-ui/uikit';
import {BenefactorModel} from '../../model';
import styles from './DetailBenefactorInformation.module.scss';

interface DetailBenefactorInformationProps {
  benefactorData: BenefactorModel | null;
  onEditEmail?: () => void;
  onEditPhone?: () => void;
}

export const DetailBenefactorInformation = ({
  benefactorData,
  onEditEmail,
  onEditPhone,
}: DetailBenefactorInformationProps) => {
  const {createNotification} = useNotifications();

  const handleCopyId = useCallback(async () => {
    if (benefactorData?.id) {
      const success = await copyToClipboard(benefactorData.id);
      if (success) {
        createNotification({
          name: 'copy-id-success',
          title: 'User ID скопирован',
          theme: 'info',
        });
      } else {
        createNotification({
          name: 'copy-id-error',
          title: 'Ошибка при копировании User ID',
          theme: 'danger',
        });
      }
    }
  }, [benefactorData?.id, createNotification]);

  if (!benefactorData) {
    return null;
  }

  return (
    <div className={styles.detailsContainer}>
      <PropertyRow property={'Display name'} value={benefactorData.displayName || ''} />
      <PropertyRow property={'Real name'} value={benefactorData.realName || '-'} />
      <PropertyRow property={'User ID'} value={benefactorData.id || '-'} icon={Copy} onclick={handleCopyId} />
      <PropertyRow
        property={'Email'}
        value={benefactorData.email || '-'}
        icon={!benefactorData.deletedAt ? Pencil : undefined}
        onclick={!benefactorData.deletedAt ? onEditEmail : undefined}
      />
      <PropertyRow
        property={'Телефон'}
        value={formatPhoneNumber(benefactorData.phoneNumber) || '-'}
        icon={!benefactorData.deletedAt ? Pencil : undefined}
        onclick={!benefactorData.deletedAt ? onEditPhone : undefined}
      />
      <PropertyRow property={'Дата регистрации'} value={formatDateToLocalDate(benefactorData.createdAt) || ''} />
      <PropertyRow
        property={'Статус'}
        value={
          <div className={styles.statusContainer}>
            <StatusLabel
              lockedAt={benefactorData.lockedAt}
              lastLoggedInAt={benefactorData.lastLoggedInAt}
              isUser={true}
            />
            {benefactorData.lockedAt && <Text variant="body-1">{formatDateToLocalDate(benefactorData.lockedAt)}</Text>}
          </div>
        }
      />
      {benefactorData.deletedAt && (
        <PropertyRow property={'Удален'} value={formatDateToLocalDate(benefactorData.deletedAt) || ''} />
      )}
    </div>
  );
};
